import { createApp } from 'vue'
import Appp from './App.vue';
import router from './router';
import store from './store/index';
import Axios from 'axios';

import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import SplitButton from 'primevue/splitbutton';
import PrimeVue from 'primevue/config';
import Sidebar from 'primevue/sidebar';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password'; 
import Menu from 'primevue/menu';
import Dropdown from 'primevue/dropdown';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputSwitch from 'primevue/inputswitch';
import FileUpload from 'primevue/fileupload';
import CardPrime from 'primevue/card';

import ProgressSpinner from 'primevue/progressspinner';
import Message from 'primevue/message';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Dialog from 'primevue/dialog';
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmDialog from 'primevue/confirmdialog';
import Textarea from 'primevue/textarea';
import Tooltip from 'primevue/tooltip';
import Tag from 'primevue/tag';
import ProgressBar from 'primevue/progressbar';
import Checkbox from 'primevue/checkbox';
import CalendarPrime from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber'; 

import MultiSelect from 'primevue/multiselect'; 

import { createPinia } from 'pinia';

import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';

import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import '@/assets/style/global-forms.css';
import '@/assets/style/admin-theme.css';

//import { checkAuthentication } from './auth'

import { installDebugLogHandlers } from '@/utils/debugLogHandlers';
import { pushDebugEntry, captureVistaContext } from '@/utils/debugLogHub';
import { isLegacyCSharpApiUrl, clearLegacySession } from '@/services/legacyAuth';

const app = createApp(Appp).use(createPinia()).use(router);
app.use(PrimeVue);
app.use(store);
installDebugLogHandlers(app);
app.config.globalProperties.$debugVista = (extra) => captureVistaContext(extra);
app.config.globalProperties.$debugNote = (title, body, opts = {}) => {
  pushDebugEntry({
    ...opts,
    type: opts.type || 'note',
    title: title == null ? 'Nota' : String(title),
    body:
      body == null
        ? ''
        : typeof body === 'string'
          ? body
          : JSON.stringify(body, null, 2),
  });
};
app.use(ConfirmationService);
app.use(ToastService);

app.component('ToolBar', Toolbar);
app.component('ButtonPrime', Button);
app.component('SplitButtonp', SplitButton);
app.component('SidebarPrime', Sidebar);
app.component('InputText', InputText);
app.component('PasswordPrime', Password);
app.component('MenuPrime', Menu);
app.component('DropdownPrime', Dropdown);
app.component('InputNumber', InputNumber);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('DataTable', DataTable);
app.component('ColumnPrime', Column);
app.component('InputSwitch', InputSwitch);
app.component('FileUpload', FileUpload);
app.component('ProgressSpinner', ProgressSpinner);
app.component('MessagePrime', Message);
app.component('AutoComplete', AutoComplete);
app.component('AccordionPrime', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('DialogPrime', Dialog);
app.component('ConfirmDialog', ConfirmDialog);
app.component('TextareaPrime', Textarea);
app.component('TagPrime', Tag);
app.component('ProgressBar', ProgressBar);
app.component('CheckBox', Checkbox);
app.component('CardPrime', CardPrime);
app.component('CalendarPrime', CalendarPrime);
app.component('MultiSelect', MultiSelect);
app.component('ToastPrime', Toast); // Registra el componente Toast


app.directive('tooltip', Tooltip);

router.isReady().then(() => {
  app.mount('#app');
});


router.beforeResolve(async (to, from, next) => {
  store.dispatch('form/submit', true)
  try {
    // await checkAuthentication(to)
    next()
  } catch (error) {
    console.log(error)
    next({ name: 'login' })
  } finally {
    store.dispatch('form/submit', false)
  }
})

Axios.interceptors.request.use(function (config) {
  const url = String(config.url || '');
  const isOAuthToken = url.endsWith('/oauth2/token/') || url.includes('/actividades-estudyoo/auth/token/');
  const isGoogleLogin = url.includes('/auth/google');
  const isAlumnoNouso = url.endsWith('/estudyoo/email/alumno-no-uso/');
  const isEstadisticaAlumnoOpcionA = url.endsWith('/estudyoo/email/estadisticas-alumno-opcion-a/');
  const isPushUsuarioNouso = url.endsWith('estudyoo/push/usuario-no-uso/');
  // APIs Django Estudyoo llevan Bearer propio (staff); no mezclar con token Google legacy
  const isEstudyooDjangoApi =
    url.includes('actividades-estudyoo') ||
    url.includes('juegos-estudyoo') ||
    url.includes('estudyoo-sync') ||
    url.includes('/simce/');

  if (
    config.method !== 'options'
    && store.getters['auth/accessToken']
    && !isOAuthToken
    && !isGoogleLogin
    && !isAlumnoNouso
    && !isEstadisticaAlumnoOpcionA
    && !isPushUsuarioNouso
    && !isEstudyooDjangoApi
  ) {
    config.headers.Authorization = `Bearer ${store.getters['auth/accessToken']}`;
    config.headers.employee = store.getters['auth/user'];
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});

Axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || '(sin URL)';
    const st = err.response?.status;
    if (st === 401) {
      if (isLegacyCSharpApiUrl(url)) {
        clearLegacySession(store);
        const routeName = router.currentRoute.value?.name;
        if (routeName && routeName !== 'login') {
          router.push({ name: 'login', query: { expired: 'legacy' } });
        }
      }
      return Promise.reject(err);
    }
    try {
      if (!err.response) {
        pushDebugEntry({
          type: 'api',
          title: 'Petición sin respuesta',
          body: `${err.message || 'Error de red'}\nURL: ${url}`,
        });
      } else if (st >= 400) {
        let dataStr = '';
        try {
          const d = err.response.data;
          dataStr = typeof d === 'string' ? d : JSON.stringify(d, null, 2);
        } catch {
          dataStr = String(err.response.data);
        }
        pushDebugEntry({
          type: 'api',
          title: `HTTP ${st}`,
          body: `URL: ${url}\n\n${dataStr.slice(0, 12000)}`,
        });
      }
    } catch {
      /* noop */
    }
    return Promise.reject(err);
  }
);
